var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavStarHeading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15867 4.55081L7.20631 0.204203C7.33663 -0.0680676 7.70891 -0.0680676 7.83923 0.204203L9.89617 4.55081C9.95199 4.65777 10.0451 4.73557 10.1661 4.75501L14.7547 5.44541C15.0432 5.48431 15.155 5.86354 14.9501 6.07747L11.6274 9.4614C11.5436 9.54894 11.5064 9.66559 11.525 9.79203L12.3068 14.5665C12.3534 14.868 12.0556 15.1012 11.7949 14.9554L7.69033 12.6995C7.58788 12.6412 7.46694 12.6412 7.36458 12.6995L3.25994 14.9554C2.99933 15.1012 2.70148 14.868 2.74802 14.5665L3.52985 9.79203C3.54847 9.67529 3.51124 9.54894 3.42747 9.4614L0.104694 6.07747C-0.100072 5.86354 0.0116134 5.49403 0.300152 5.44541L4.88875 4.74529C5.00044 4.72583 5.10282 4.64805 5.14936 4.54109L5.15867 4.55081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavStarHeading);
export default __webpack_public_path__ + "static/media/fav-star-heading.ebc4d58963582c751b91d6b1228432c8.svg";
export { ForwardRef as ReactComponent };